export function useCountdownTimer(
  durationMs: number,
  startTimeDate?: Date,
  callback?: () => void,
) {
  startTimeDate = startTimeDate ?? new Date()

  const now = useNow({ interval: 500 })

  const elapsedMs = computed(
    () => now.value.getTime() - startTimeDate.getTime(),
  )

  const remainingMs = computed(() => {
    if (elapsedMs.value < 0) {
      return durationMs
    }

    if (elapsedMs.value >= durationMs) {
      return 0
    }

    return durationMs - elapsedMs.value
  })

  watch(remainingMs, (newRemainingMs) => {
    if (newRemainingMs === 0 && callback) {
      callback()
    }
  })

  return { remainingMs }
}
